import { apiCall } from "../helpers/api";


export const audience = (params = {}) => (dispatch) => {
  params.path = params.path || "audiences";
  return dispatch(apiCall(params));
}